import { IResourceType } from '../types/IResourceType'
import { AccessLevel } from '../types/AccessLevel'
import { IResourceTypeIcon } from '../types/IResourceTypeIcon'
import { IResourceTypeComponents } from '../types/IResourceTypeComponents'
import { Sample } from './Sample'
import { AlreadyInCartType } from '../types/helperTypes'
import { ICartItem } from '../types/ICartItem'
import { IResource } from '../types/IResource'
import { RESOURCE_TYPE_NAMES } from 'utils'

export class ManagementRoleType implements IResourceType {
    name = RESOURCE_TYPE_NAMES.MANAGEMENT_ROLES

    route = '/managementRoles'

    title = 'Common_ManagementRoles'

    access: AccessLevel = {
        page: 'ITShop-ManagementRoles-Page',
    }

    icon: IResourceTypeIcon = {
        small: 'ManagementRolesSmall',
        large: 'ManagementRolesLarge',
    }

    manageAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    requestAccessComponents: IResourceTypeComponents = {
        cardComponent: Sample,

        rowComponent: Sample,

        detailComponent: Sample,
    }

    filters = []

    attributes = []

    cartComponent = null

    alreadyInCart: AlreadyInCartType = (
        cartItems: ICartItem[],
        resource: IResource,
    ) =>
        cartItems.find((c) => c.requestableResourceId === resource.id) !==
        undefined
}
